module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-12-13-403_com.pinkcoffee.sexbattle.bd0f9700.jpg";